// API Configuration for Kalimat AI App
// This file centralizes all API endpoint configurations
import { isAndroidOverlay } from '../utils/androidBridge';
import { isExtension } from '../utils/extensionBridge';

// Determine if we're running in a Tauri-managed webview
const isTauri = typeof window !== 'undefined' && (window as any).__TAURI_INTERNALS__;

// The Android overlays (FloatingOverlay.kt/CorrectionPopupOverlay.kt) are
// plain WebViews, not Tauri-managed ones, so __TAURI_INTERNALS__ is never
// injected there - but they're still the real app hitting the real backend,
// not a website visitor, and need the same absolute production URL as
// isTauri does. Without this, it falls through to the "relative /api path"
// branch below, which resolves against tauri.localhost (Tauri's own
// asset-serving domain) instead of the real backend, and every request 404s.
//
// The browser extension's content script has the exact same problem for a
// different reason: window.location.hostname there is whatever arbitrary
// webpage the popup was injected into (e.g. "github.com"), not kalimatai.com -
// so without isExtension here too, every request would resolve against that
// unrelated page's own origin instead of the real backend.

// Check if we're in development mode
const isDevelopment = typeof window !== 'undefined' &&
                     (window.location.hostname === 'localhost' ||
                      window.location.hostname === '127.0.0.1');

// Define the base API URL based on the environment
const API_BASE_URL = (isTauri || isAndroidOverlay || isExtension)
    ? 'https://kalimatai.com/api'  // Production backend for Tauri app/api'  // Production backend for Tauri app
  : isDevelopment
    ? 'http://localhost:3005/api'  // Development backend
    : '/api';                      // Relative path for production web app

// Define the base URL without the /api suffix (for direct backend access)
const BASE_URL = (isTauri || isAndroidOverlay || isExtension)
  ? 'https://kalimatai.com'      // Production backend for Tauri app
  : isDevelopment
    ? 'http://localhost:3005'      // Development backend
    : '';                          // Empty for production web app (relative paths)

export { API_BASE_URL, BASE_URL };